import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, Stack } from "@mui/material";

import { bottomButton } from "../../common/styles";
import { getReceiptHistory } from "../../server/axios";

//共通コンポーネント
import { Header, MainColorButton, Loading } from "../../components";

/**
 * 受取薬明細画面
 * @returns
 */
const ReceiveMedicationDetails = () => {
  const location = useLocation();
  // Loadingコンポネント表示非表示state
  const [loadingOpen, setLoadingOpen] = useState(false);

  //処方日
  const [supplyDate, setSupplyDate] = useState("");

  // 患者氏名
  const [patientName, setPatientName] = useState("");

  //医療機関
  const [publisherName, setPublisherName] = useState("");

  //医師
  const [doctorName, setDoctorName] = useState("");

  //処方薬局
  const [dispensaryName, setDispensaryName] = useState("");

  //薬剤師
  const [pharmacistName, setPharmacistName] = useState("");

  //服薬情報
  const [usages, setUsages] = useState([]);

  //注意事項
  const [comments, setComments] = useState([]);

  let medicalOrder = 0;

  const valueStackStyle = {
    border: "1px solid black",
    width: "70%",
    height: "4.5vh",
    borderBottom: "none",
    paddingLeft: "1%",
  };

  // 初期表示処理
  useEffect(() => {
    setLoadingOpen(true);

    const { customerId, siteId, familyId, recordId, userName } = location.state;
    setPatientName(userName);
    getReceiptHistory({
      mode: "detail",
      customerId: customerId,
      siteId: siteId,
      familyId: familyId,
      recordId: recordId,
    }).then((res) => {
      if (res.data && res.data.detailData?.length !== 0) {
        setLoadingOpen(false);

        setPublisherName(res.data.detailData.publisherName);
        setDoctorName(res.data.detailData.doctorName);
        setDispensaryName(res.data.detailData.dispensaryName);
        setPharmacistName(res.data.detailData.pharmacistName);
        setSupplyDate(res.data.detailData.supplyDate);
        setUsages(res.data.detailData.usages);
        setComments(res.data.detailData.comments);
      }
    });
  }, []);

  return (
    <>
      <Loading open={loadingOpen} />
      <Header title="受取薬明細" />
      <Stack
        height="82vh"
        width="95%"
        marginTop="9vh"
        marginLeft="auto"
        marginRight="auto"
        sx={{ overflowY: "scroll" }}
      >
        <Stack direction="row" alignItems="center" width="95%" marginTop="1vh">
          <Box width="30%">
            <Typography>患者様名</Typography>
          </Box>
          <Stack sx={valueStackStyle} alignItems="center" direction="row">
            <Typography>{patientName}</Typography>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" width="95%">
          <Box width="30%">
            <Typography>医療機関</Typography>
          </Box>
          <Stack sx={valueStackStyle} alignItems="center" direction="row">
            <Typography>{publisherName}</Typography>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" width="95%">
          <Box width="30%">
            <Typography>医師</Typography>
          </Box>
          <Stack sx={valueStackStyle} alignItems="center" direction="row">
            <Typography>{doctorName}</Typography>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" width="95%">
          <Box width="30%">
            <Typography>処方薬局</Typography>
          </Box>
          <Stack sx={valueStackStyle} direction="row" alignItems="center">
            <Typography>{dispensaryName}</Typography>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" width="95%">
          <Box width="30%">
            <Typography>薬剤師</Typography>
          </Box>
          <Stack
            sx={{ ...valueStackStyle, borderBottom: "" }}
            alignItems="center"
            direction="row"
          >
            <Typography>{pharmacistName}</Typography>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center" width="95%">
          <Box width="30%">
            <Typography>処方日</Typography>
          </Box>
          <Stack
            sx={{
              ...valueStackStyle,
              width: "30%",
              borderBottom: "",
              borderTop: "none",
            }}
            direction="row"
            alignItems="center"
          >
            <Typography>{supplyDate}</Typography>
          </Stack>
          <Box width="40%"></Box>
        </Stack>
        <Stack width="95%" marginTop="5%">
          <Typography>処方薬</Typography>
          <Box
            sx={{
              height: "33vh",
              overflowY: "scroll",
            }}
          >
            {usages.map((item, index) => (
              <Box key={index}>
                <Stack direction="row" alignItems="center" marginLeft="8%">
                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ border: "1px solid", width: "100%", height: "4.5vh" }}
                  >
                    <Typography>{item.usageName}</Typography>
                  </Stack>
                </Stack>
                {item.medicines.map((t, key) => (
                  <Stack key={key}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      sx={{ marginLeft: "8%" }}
                    >
                      <Typography align="right" width="10%">
                        {(medicalOrder = medicalOrder + 1)}
                      </Typography>
                      <Stack
                        direction="row"
                        alignItems="center"
                        sx={{
                          width: "100%",
                          minHeight: "4.5vh",
                          border: "1px solid black",
                          borderTop: "none",
                          paddingLeft: "1%",
                          borderBottom:
                            key !== item.medicines.length - 1 ||
                            (index === usages.length - 1 &&
                              key === item.medicines.length - 1)
                              ? ""
                              : "none",
                        }}
                      >
                        <Typography>{t}</Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                ))}
              </Box>
            ))}
          </Box>
        </Stack>
        <Stack width="95%" marginTop="5%" marginBottom="3vh">
          <Box>
            <Typography>注意事項</Typography>
            <Box
              sx={{
                border: "1px solid",
                minHeight: "10vh",
              }}
            >
              {comments &&
                comments.length > 0 &&
                comments.map((item, index) => {
                  return (
                    <Typography variant="body2" key={index} align="left">
                      {item}
                    </Typography>
                  );
                })}
            </Box>
          </Box>
        </Stack>
      </Stack>
      <MainColorButton label="戻る" style={bottomButton} />
    </>
  );
};
export default ReceiveMedicationDetails;
